import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { ValidationErrors } from 'webapp-types';
import { ReportLayout } from 'webapp/enums/enums';

import BoardsShareScheduleAdvancedSettingsComponent from 'webapp/components/boards/share/schedule/advanced-settings';
import BoardsShareScheduleFormatSwitcherComponent from 'webapp/components/boards/share/schedule/format-switcher';
import FormEmailAndSlackRecipientsComponent from 'webapp/components/form/email-and-slack-recipients';
import FormScheduleComponent from 'webapp/components/form/schedule';

import type ReportScheduleSetting from 'webapp/models-custom/report-schedule-setting';

interface Args {
	model: ReportScheduleSetting;
	isPeriodic: boolean;
	submitInProgress: boolean;
	errors: ValidationErrors<string>;
	theme?: string;
	onContentChange?: () => void;
}

export default class ReportsShareScheduleFormComponent extends Component<Args> {
	get hasRecipients(): boolean {
		return this.args.model.recipients.length > 0;
	}

	get isPagelessFormat(): boolean {
		return this.args.model.layout === ReportLayout.PAGELESS;
	}

	get recipientsTrackingOrigin() {
		return this.args.isPeriodic ? 'scheduled_report' : 'send_report_now';
	}

	get addSendToTextToLabels() {
		return !this.args.isPeriodic;
	}

	@action
	changeFormat(isPageless: boolean): void {
		this.args.model.layout = isPageless ? ReportLayout.PAGELESS : ReportLayout.SLIDES;
		if (isPageless) {
			this.args.model.includeBgImages = false;
		}
		this.onContentChange();
	}

	@action
	onContentChange() {
		this.args.onContentChange?.();
	}
	<template>
		<FormEmailAndSlackRecipientsComponent
			@model={{@model}}
			@errors={{@errors}}
			@origin={{this.recipientsTrackingOrigin}}
			@submitInProgress={{@submitInProgress}}
			@onContentChange={{this.onContentChange}}
			@addSendToTextToLabels={{this.addSendToTextToLabels}}
			@theme={{@theme}}
		/>

		{{#if @isPeriodic}}
			<FormScheduleComponent
				@model={{@model}}
				@showOneOff={{false}}
				@submitInProgress={{@submitInProgress}}
				@theme={{@theme}}
			/>
		{{/if}}

		<BoardsShareScheduleFormatSwitcherComponent
			@isPageless={{this.isPagelessFormat}}
			@onChange={{this.changeFormat}}
		/>

		<BoardsShareScheduleAdvancedSettingsComponent
			@model={{@model}}
			@isPeriodic={{@isPeriodic}}
			@isPagelessFormat={{this.isPagelessFormat}}
			@submitInProgress={{@submitInProgress}}
			@onContentChange={{this.onContentChange}}
		/>
	</template>
}
